export { ethereumMock } from './ethereumMock';
